import React from '../../_snowpack/pkg/react.js';
import styled from '../../_snowpack/pkg/styled-components.js';
const dark = '#828A90';
const green = '#DAF0ED';
const Outer = styled.div.withConfig({
  displayName: "auto-save__Outer",
  componentId: "sc-1afnnl5-0"
})(["width:18px;height:22px;background:", ";border-radius:2px;border:1px solid ", ";position:relative;"], p => p.isLoading ? '#fff' : green, dark);
const Success = styled.div.withConfig({
  displayName: "auto-save__Success",
  componentId: "sc-1afnnl5-1"
})(["position:absolute;width:14px;height:14px;border-radius:50%;right:0;bottom:-6px;svg{position:absolute;width:7px;height:7px;}"]);
const Line = styled.div.withConfig({
  displayName: "auto-save__Line",
  componentId: "sc-1afnnl5-2"
})(["width:", ";height:1px;left:3px;position:absolute;border-radius:1px;top:", ";background:", ";&.one{animation:one 1.7s infinite;}&.two{animation:two 1.7s infinite;}&.three{animation:three 1.7s infinite;}@keyframes one{0%{opacity:0;width:0;}5%{opacity:1;}95%{opacity:1;width:10px;}100%{opacity:0;width:10px;}}@keyframes two{0%{opacity:0;width:0;}5%{opacity:1;}95%{opacity:1;width:10px;}100%{opacity:0;width:10px;}}@keyframes three{0%{opacity:0;width:0;}5%{opacity:1;}95%{opacity:1;width:5px;}100%{opacity:0;width:5px;}}}"], p => p.half ? '5px' : '10px', p => p.top, dark);

const CheckMark = () => {
  return /*#__PURE__*/React.createElement(Success, null, /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 278.922 278.922"
  }, /*#__PURE__*/React.createElement("path", {
    fill: dark,
    d: "M128.775,265.136l146.36-214.392c6.772-9.926,4.215-23.459-5.706-30.236L251.459,8.244 c-9.921-6.772-23.464-4.221-30.236,5.706L100.171,191.268l-53.14-37.916c-9.779-6.978-23.366-4.71-30.345,5.075l-12.64,17.71 c-6.978,9.779-4.705,23.366,5.075,30.345l89.679,63.985C108.58,277.445,122.004,275.057,128.775,265.136z"
  })));
};

const Loader = ({
  loading = false
}) => {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Outer, {
    isLoading: loading
  }, !loading && /*#__PURE__*/React.createElement(CheckMark, null), /*#__PURE__*/React.createElement(Line, {
    top: "4px",
    className: loading ? 'one' : ''
  }), /*#__PURE__*/React.createElement(Line, {
    top: "8px",
    className: loading ? 'two' : ''
  }), /*#__PURE__*/React.createElement(Line, {
    top: "12px",
    className: loading ? 'three' : '',
    half: true
  })));
};

export default Loader;